import {
  USERS,
  USERS_CREATE,
  USERS_MODIFY,
  USER_DETAIL,
} from "@constants/routes";
import CreateUser from "@pages/Users/CreateUser";
import UserDetail from "@pages/Users/DetailUser";
import Users from "@pages/Users/ListUsers";
import ModifyUser from "@pages/Users/ModifyUser";
import { Route, Switch } from "react-router-dom";

const Security = () => (
  <Switch>
    <Route exact path={USERS} component={Users} />
    <Route exact path={USERS_CREATE} component={CreateUser} />
    <Route exact path={USERS_MODIFY} component={ModifyUser} />
    <Route exact path={USER_DETAIL} component={UserDetail} />
  </Switch>
);

export default Security;
